"use client";

import SectionHeader from "@/components/SectionHeader";
import Swiper from "@/components/swiper";
import TabSwitcher from "@/components/TabSwitcher";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { Link } from "@/i18n/navigation";
import { getLocalizedPath } from "@/utils/pathUtils";
import { PATHS } from "@/constants/pathnames";
import { useLocale } from "next-intl";
import Image from "next/image";
import React, { useCallback, useState } from "react";
import { SwiperSlide } from "swiper/react";
import { ProductType, TrackingEvent, useAnalyticsContext } from "@/analytics";
import { getFerryLocationImageUrl } from "@/utils/ferry/getCdnImagePath";

function FerryPopularLocations(props) {
  const t = useTranslationDetector("ferry");
  const [activeTab, setActiveTab] = useState("islands");
  const locale = useLocale();
  const { dispatch: trackingDispatch } = useAnalyticsContext();
  const handleCtaClick = useCallback((data) => {
    trackingDispatch({
      type: TrackingEvent.CTA_CLICK,
      payload: {
        productType: ProductType.FERRY,
        cta_button: data.Description,
        cta_category: t("popularDestinations"),
        cta_language: locale,
      },
    });
  }, [locale, trackingDispatch]);
  return (
    <div>
      <SectionHeader
        title={t("popularDestinations")}
        className="mb-6"
      />
      <TabSwitcher
        className="mb-6"
        tabs={[
          { id: "islands", label: t("popularIslands") },
          { id: "locations", label: t("popularLocations") },
          { id: "international", label: t("popularInternational") },
        ]}
        selected={activeTab}
        onChange={setActiveTab}
      />
      <Swiper
        key={activeTab}
        swiperOptions={{
          slidesPerView: "auto",
          pagination: false,
          navigation: false,
        }}
      >
        {props?.stats[activeTab]?.map((data, index) => {
          return (
            <SwiperSlide
              key={index}
              className="swiper-aspect-1-5 sm:swiper-aspect-4-5 lg:swiper-aspect-6"
            >
              <Link onClick={() => handleCtaClick(data)} href={getLocalizedPath(PATHS.FERRY_TICKET.PATH, locale) + "/" + data.Slug} className="w-full block">
                <Image
                  className="h-auto! w-full! rounded-lg"
                  src={getFerryLocationImageUrl(data.Slug)}
                  width={186}
                  height={240}
                  alt={data.Description ?? ""}
                  quality={95}
                  priority={index === 0}
                />
                <span className="absolute bottom-6 left-6 z-10 text-xl/26 font-medium text-white">
                  {data.Destination || data.Description}
                </span>
              </Link>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default FerryPopularLocations;
